import React from "react";
import { Box, Chip, Stack, TextField, Typography } from "@mui/material";
import { QUICK_SECTION_OPTIONS } from "../../utils/classStreamUtils";

/**
 * Comma-separated class sections (A, B, …) with quick-add chips and name preview.
 */
export default function StreamSectionsInput({
    value,
    onChange,
    onQuickAdd,
    previewNames = [],
    helperText,
    label = "Class sections",
    placeholder = "e.g. A, B — each section becomes its own class (Form 1 A, Form 1 B)",
}) {
    return (
        <Stack spacing={1.5}>
            <TextField
                fullWidth
                label={label}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                helperText={
                    helperText ||
                    "Separate sections with commas. Leave blank for one class per level with no letter (e.g. Form 1 only)."
                }
            />
            <Box>
                <Typography variant="caption" color="text.secondary" sx={{ mr: 1 }}>
                    Quick add:
                </Typography>
                <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap component="span">
                    {QUICK_SECTION_OPTIONS.map((section) => (
                        <Chip
                            key={section}
                            label={section}
                            size="small"
                            variant="outlined"
                            onClick={() => onQuickAdd(section)}
                            sx={{ cursor: "pointer" }}
                        />
                    ))}
                </Stack>
            </Box>
            {previewNames.length > 0 ? (
                <Box
                    sx={{
                        p: 1.5,
                        borderRadius: 2,
                        bgcolor: (t) => (t.palette.mode === "light" ? "grey.50" : "action.hover"),
                        border: (t) => `1px solid ${t.palette.divider}`,
                    }}
                >
                    <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                        {previewNames.length} class{previewNames.length !== 1 ? "es" : ""} will be created:
                    </Typography>
                    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ mt: 0.5 }}>
                        {previewNames.map((name) => (
                            <Chip key={name} label={name} size="small" color="primary" variant="outlined" />
                        ))}
                    </Stack>
                </Box>
            ) : null}
        </Stack>
    );
}
